module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-students"
  }, [_c('button', {
    staticClass: "bttn bttn--primary",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": _vm.setIsShowModal
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.students.create_student')) + "\n  ")]), _vm._v(" "), (_vm.isShowModal) ? _c('Modal', {
    attrs: {
      "is-bg-overlay": true,
      "show-close": false,
      "show": true
    },
    on: {
      "close": _vm.setCloseModal
    }
  }, [_c('div', {
    staticClass: "doc-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "doc-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + " "), (!_vm.isCreateMultipleStudents) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.student')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])]), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__close icon__bg-circle",
    on: {
      "click": _vm.setCloseModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.isCreateMultipleStudents) ? _c('div', {
    staticClass: "doc-modal__body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.insert_multiple_students')))]), _vm._v(" "), _c('div', {
    staticClass: "textarea-placeholder-container"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theBulkStudentsStr),
      expression: "theBulkStudentsStr"
    }],
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "spellcheck": "false",
      "autocapitalize": "none",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.theBulkStudentsStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.theBulkStudentsStr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTextAreaPlaceholder),
      expression: "isShowTextAreaPlaceholder"
    }],
    staticClass: "textarea-placeholder-container__placeholder"
  }, [_vm._v("\n              Anne Anker\n              "), _c('br'), _vm._v(" Ella Madsen\n              "), _c('br'), _vm._v(" Michael Thomsen\n            ")])])])]) : _vm._l((_vm.students), function(student, key) {
    return _c('div', {
      staticClass: "doc-modal__body"
    }, [(_vm.isFeideActive) ? _c('div', {
      staticClass: "d-input-group"
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.feide),
        expression: "student.feide"
      }],
      ref: "feide",
      refInFor: true,
      staticClass: "d-input feide",
      class: [{
        'input--error': _vm.isFeideAlreadyCreated
      }],
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (student.feide)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(student, "feide", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.isFeideAlreadyCreated) ? _c('p', {
      staticClass: "text--error"
    }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide_is_already_used')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "d-input-group"
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v(_vm._s(_vm.$t('vue2.students.name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.name),
        expression: "student.name"
      }],
      ref: "studentname",
      refInFor: true,
      staticClass: "d-input namefield",
      class: [{
        'missing-input': false
      }],
      attrs: {
        "type": "text",
        "id": 'studentname_' + key,
        "placeholder": ""
      },
      domProps: {
        "value": (student.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(student, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('SearchForCalendar', {
      attrs: {
        "query": student.name
      }
    }), _vm._v(" "), (student.name.length < 1) ? _c('p', {
      staticClass: "text-blue pointer text-link",
      on: {
        "click": function($event) {
          _vm.isCreateMultipleStudents = !_vm.isCreateMultipleStudents
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.students.create_multiple_students')))]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__footer"
  }, [_c('button', {
    staticClass: "marg-1-right",
    on: {
      "click": _vm.setCloseModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "submit-button bttn--shadow",
    class: {
      'create-form__submit': _vm.showInactiveButton
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.create')) + " "), (!_vm.isCreateMultipleStudents) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.student')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])])])], 2)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a073072!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateStudents/CreateStudents.vue
// module id = 2028
// module chunks = 1